import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getAccentraStatusQueryKey } from './get-accentra-status'

type UpdateAccentraConnectionRequest = {
  buildingId: number
  login: string
  password: string
}

const updateAccentraConnection = async (data: UpdateAccentraConnectionRequest) => {
  const { buildingId, ...body } = data
  const response = await integrationAPI.post(
    `/building/${buildingId}/accentra-integration/admin-credential`,
    body,
  )
  return response.data
}

export const useUpdateAccentraConnection = () =>
  useMutation({
    mutationFn: updateAccentraConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getAccentraStatusQueryKey({ buildingId: variables.buildingId })])
    },
  })
